._tagsContainer_1x2re_1 {
  display: flex;
  flex-wrap: wrap;
}
._tagsContainer_1x2re_1 > * {
  margin-bottom: var(--spacing-xs);
}